<template>
  <div id="app">
    <headerComponent :seller="seller"></headerComponent>
    <div class="tab-wrap border-1px">
      <div class="item">
        <router-link to="/goods">商品</router-link>
      </div>
      <div class="item">
        <router-link to="/ratings">评论</router-link>
      </div>
      <div class="item">
        <router-link to="/seller">商家</router-link>
      </div>
    </div>
    <keep-alive>
      <router-view :seller="seller"></router-view>
    </keep-alive>
  </div>
</template>

<script type="text/ecmascript-6">
  import headerComponent from 'components/header/header.vue';
  /* eslint-disable no-unused-vars */
  import {localdata} from 'common/js/data.js';
  export default {
    name: 'app',
    data() {
      return {
        seller: localdata.seller
      };
    },
    components: {
      headerComponent
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "common/stylus/mixin.styl";
  .tab-wrap
    display:flex
    width:100%
    height:40px
    background-color:#fff
    border-1px(rgba(7,17,27,0.1))
    .item
      flex:1
      text-align:center
      a
        font-size:14px
        line-height:40px
        color:rgb(77,85,93)
        &.active
          color:rgb(240,20,20)
</style>



// WEBPACK FOOTER //
// App.vue?0af4b49c